import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Tree } from 'antd';
import PropTypes from 'prop-types';
import {
  CollapseBlock,
  SortItemRenderer,
  DisabledWithSpinner,
} from '../../../../common/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { useTranslation } from 'react-i18next';
import useOnTreeDrop from '../../../../../hooks/useOnTreeDrop.jsx';
import FormButton from '../../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';

const nestedMap = (arr) => {
  const result = arr.map((row) => {
    if (row.children && row.children.length) {
      const children = nestedMap(row.children);
      return { ...row, key: row.id, children };
    } else {
      return { ...row, key: row.id, children: [] };
    }
  });
  return result;
};

const MenuSortOrder = ({
  menu,
  requestInProgress,
  onOrderSave,
  languagePicker,
  isEnglish,
}) => {
  const [menuData, setMenuData] = useState(nestedMap(menu));
  const { t } = useTranslation();

  useEffect(() => {
    setMenuData(nestedMap(menu));
  }, [menu]);

  const onDrop = useOnTreeDrop(menuData, (data) => {
    setMenuData(data);
  });

  return (
    <>
      <AppBarCMS
        title={t('Úprava poradia položiek menu')}
        backUrl={routes.cmsMenu}
        backUrlTooltip={t('Tabuľka menu')}
        permissionsBasic={'menu'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <Row>
            <Col span={12}>{languagePicker && languagePicker}</Col>
          </Row>

          {requestInProgress && <DisabledWithSpinner />}

          <Tree
            className="draggable-tree"
            draggable
            blockNode
            showLine
            onDrop={onDrop}
            treeData={menuData}
            titleRender={(node) => (
              <NodeItem key={node.menu_id} node={node} isEnglish={isEnglish} />
            )}
          />
        </CollapseBlock>
        <FormButtonsContainer>
          <FormButton onClick={() => onOrderSave(menuData)}>
            {t('Uložiť')}
          </FormButton>
        </FormButtonsContainer>
      </div>
    </>
  );
};

MenuSortOrder.propTypes = {
  isEnglish: PropTypes.bool, // BE CAREFULL !! this is not english used for locale all strings but switch
  menu: PropTypes.array,
  requestInProgress: PropTypes.bool,
  onOrderSave: PropTypes.func,
  languagePicker: PropTypes.any,
};

export default MenuSortOrder;

function NodeItem({ node, isEnglish, showActions }) {
  const { t } = useTranslation();

  const itemTitle = useMemo(() => {
    if (node.article_id && node.article) {
      return isEnglish ? node.article.title_en : node.article.title_sk;
    }

    return isEnglish ? node.text_en : node.text_sk;
  }, [isEnglish, node]);

  return (
    <SortItemRenderer
      key={node.id}
      title={itemTitle}
      block_id={node.id}
      actions={showActions ? actions : []}
    />
  );
}
